import { FEATURE_CODES, hasFeature } from './features.js';
import { isEconomistProfile } from './profileRoles.js';

const ECONOMIST_ALLOWED_PATHS = [
  /^\/main\/?$/,
  /^\/profile\/?$/,
  /^\/sessions\/?$/,
  /^\/2fa-settings\/?$/,
  /^\/notifications\/?$/,
  /^\/profitability(?:\/.*)?$/,
  /^\/billing(?:\/.*)?$/,
  /^\/freight-forwarding\/billing\/?$/,
  /^\/drivers\/?$/,
  /^\/transports\/?$/,
  /^\/trucks\/?$/,
  /^\/trailers\/?$/,
  /^\/fleet\/(?:cars|vans)\/?$/,
  /^\/fleet\/(?:cars|vans)\/[^/]+\/edit\/?$/,
];

export const isEconomistPathAllowed = (pathname = '') => (
  ECONOMIST_ALLOWED_PATHS.some((pattern) => pattern.test(pathname))
);

export const getEconomistRequiredFeaturesForPath = (pathname = '') => {
  if (/^\/billing(?:\/.*)?$/.test(pathname)) {
    return [FEATURE_CODES.EFACTURA];
  }
  if (/^\/freight-forwarding\/billing\/?$/.test(pathname)) {
    return [FEATURE_CODES.TRANSPORT_MANAGEMENT, FEATURE_CODES.FREIGHT_FORWARDING];
  }
  if (/^\/profitability\/invoice-generator\/?$/.test(pathname)) {
    return [FEATURE_CODES.PROFITABILITY, FEATURE_CODES.LKW_INVOICE_EXTRACTION];
  }
  if (/^\/profitability(?:\/.*)?$/.test(pathname)) {
    return [FEATURE_CODES.PROFITABILITY];
  }
  if (/^\/drivers\/?$/.test(pathname)) {
    return [FEATURE_CODES.PROFITABILITY, FEATURE_CODES.WORKFORCE_MANAGEMENT];
  }
  if (/^\/transports\/?$/.test(pathname)) {
    return [FEATURE_CODES.PROFITABILITY, FEATURE_CODES.TRANSPORT_MANAGEMENT];
  }
  if (
    /^\/(?:trucks|trailers)\/?$/.test(pathname)
    || /^\/fleet\/(?:cars|vans)(?:\/[^/]+\/edit)?\/?$/.test(pathname)
  ) {
    return [FEATURE_CODES.PROFITABILITY, FEATURE_CODES.FLEET_MANAGEMENT];
  }
  return [];
};

export const getEconomistCapabilities = (profile, features) => {
  const isEconomist = isEconomistProfile(profile);
  const profitabilityEnabled = hasFeature(features, FEATURE_CODES.PROFITABILITY);
  const fleetEnabled = hasFeature(features, FEATURE_CODES.FLEET_MANAGEMENT);
  const workforceEnabled = hasFeature(features, FEATURE_CODES.WORKFORCE_MANAGEMENT);
  const transportEnabled = hasFeature(features, FEATURE_CODES.TRANSPORT_MANAGEMENT);

  return {
    isEconomist,
    canUseProfitability: isEconomist && profitabilityEnabled,
    canViewVehicles: isEconomist && profitabilityEnabled && fleetEnabled,
    canEditVehicles: isEconomist && profitabilityEnabled && fleetEnabled,
    canCreateVehicles: false,
    canDeleteVehicles: false,
    canViewDrivers: isEconomist && profitabilityEnabled && workforceEnabled,
    canEditDrivers: isEconomist && profitabilityEnabled && workforceEnabled,
    canEditDriverSalary: isEconomist && profitabilityEnabled && workforceEnabled,
    canCreateDrivers: false,
    canDeleteDrivers: isEconomist && profitabilityEnabled && workforceEnabled,
    canViewTransports: isEconomist && profitabilityEnabled && transportEnabled,
    canCreateTransports: false,
    canEditTransports: false,
    canDeleteTransports: false,
  };
};
